import { render, staticRenderFns } from "./SeparationLine.vue?vue&type=template&id=28add7e2&"
import script from "./SeparationLine.vue?vue&type=script&lang=js&"
export * from "./SeparationLine.vue?vue&type=script&lang=js&"
import style0 from "./SeparationLine.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports